module.exports = __webpack_public_path__ + "media/images/gallery/constellations/variables_layer_on-19638b466f468f9f0c8a4316c2152d22.jpg";